module.exports = __webpack_public_path__ + "img/trofimova.239c1ef1.jpg";